import React from "react";
import { Col } from "reactstrap";

const GradedProgressBar = ({ title, value, count = 4, labels = [] }) => {
  const safeValue = Math.min(Math.max(value || 0, 0), count - 1);
  const filledCount = safeValue + 1;

  return (
    <Col lg>
      <div
        className="block-wrapper-inner-item block-wrapper-inner-item--stats"
        style={{ paddingBottom: "9px" }}
      >
        <h4>{title}</h4>
        <div style={{ position: "relative" }}>
          <div className="d-flex align-items-center" style={{ width: "100%" }}>
            {Array.from({ length: count }).map((_, index) => (
              <span
                key={index}
                className={`round-item-wrap-bg-feature-box ${
                  index < filledCount ? "colored" : ""
                }`}
              />
            ))}
          </div>
          <div
            className="d-flex justify-content-between"
            style={{ marginTop: "8px", color: "#878a99" }}
          >
            {labels.map((label, index) => (
              <span
                key={index}
                style={{
                  width: "100%",
                  textAlign: "center",
                  fontSize: "14px",
                  fontWeight: index === safeValue ? "bold" : "normal",
                  color: index === safeValue ? "#242424" : "inherit",
                }}
              >
                {label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Col>
  );
};

export default GradedProgressBar;
